import { toTrimmedNonEmptyString } from '@/lib/utils/type-guards';
import type { UserPreviewVM } from '@/lib/view-models/user-preview';

export const hasMeaningfulPreview = (preview?: UserPreviewVM): boolean => {
  if (!preview) {
    return false;
  }

  if (toTrimmedNonEmptyString(preview.description)) {
    return true;
  }
  if (toTrimmedNonEmptyString(preview.location)) {
    return true;
  }
  if (typeof preview.profileImageUrl === 'string' && preview.profileImageUrl.length > 0) {
    return true;
  }
  if (typeof preview.profileBannerUrl === 'string' && preview.profileBannerUrl.length > 0) {
    return true;
  }

  const numericFields: Array<number | undefined> = [
    preview.followersCount,
    preview.followingCount,
    preview.tweetCount,
    preview.listedCount,
    preview.totalInteractions,
  ];
  if (numericFields.some((value) => typeof value === 'number')) {
    return true;
  }

  if (typeof preview.isFollowing === 'boolean' || typeof preview.followsYou === 'boolean') {
    return true;
  }

  if (Array.isArray(preview.affiliations) && preview.affiliations.length > 0) {
    return true;
  }

  return false;
};
